<div
  [ngClass]="{
    'after-deadline': daysToDeadline() < 0,
    'soon': daysToDeadline() <= 3 && daysToDeadline() >= 0,
  }"
  class="deadline"
>
  <div class="deadline__icon">
    <img src="/assets/img/warning-small-svgrepo-com.svg" alt="">
  </div>
  <span>{{ daysToDeadline() < 0 ? ('afterDeadline' | translate) : (('labels.for' | translate) + ' ' + daysToDeadline() + ' ' + ('days'|translate)) }}</span>
</div>
